module.exports = __webpack_public_path__ + "img/bug.fafc1223.svg";